import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    formName: 'default', // Название формы по умолчанию
};

const formNameSlice = createSlice({
    name: 'formName',
    initialState,
    reducers: {
        setFormName: (state, action) => {
            state.formName = action.payload; // Обновление названия формы
        },
    },
});

// Экспортируем действие для изменения названия формы
export const { setFormName } = formNameSlice.actions;

// Экспортируем редюсер для добавления в хранилище
export default formNameSlice.reducer;
